import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.91667 11.6667C9.91667 10.7002 8.61083 9.91666 7 9.91666C5.38917 9.91666 4.08333 10.7002 4.08333 11.6667M12.25 9.91687C12.25 9.19926 11.5301 8.58253 10.5 8.31249M1.75 9.91687C1.75 9.19926 2.46989 8.58253 3.5 8.31249M10.5 5.97105C10.858 5.65061 11.0833 5.18495 11.0833 4.66666C11.0833 3.70016 10.2998 2.91666 9.33333 2.91666C8.88513 2.91666 8.47627 3.08515 8.16667 3.36226M3.5 5.97105C3.14198 5.65061 2.91667 5.18495 2.91667 4.66666C2.91667 3.70016 3.70017 2.91666 4.66667 2.91666C5.11487 2.91666 5.52373 3.08515 5.83333 3.36226M7 8.16666C6.0335 8.16666 5.25 7.38315 5.25 6.41666C5.25 5.45016 6.0335 4.66666 7 4.66666C7.9665 4.66666 8.75 5.45016 8.75 6.41666C8.75 7.38315 7.9665 8.16666 7 8.16666Z",
      stroke: "#94A3B8",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }